'use strict';

module.exports = {
    SIGN: 'Accedi',
    SIGN_JOIN: 'Registrati o diventa membro gratis!',
    EMAIL_EXISTS: 'Questo account esiste già.',
    INVALID_EMAIL: 'Inserisci un indirizzo e-mail valido',
    INVALID_FIRST_NAME: 'Inserisci un nome valido',
    INVALID_LAST_NAME: 'Inserisci un cognome valido',
    INVALID_PASSWORD: 'Inserisci da 6 a 20 caratteri (solo A-Z, a-z, 0-9)',
    INVALID_REPASSWORD: 'Le password non corrispondono',
    INVALID_VALID_CODE: 'Inserisci un codice valido',
    UNAVIALABLE_SERVICE: 'Ihr Service ist zur Zeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
    EMPTY_VALID_CODE: 'Digita solo i caratteri che vedi nell\'immagine',
    NOT_MEMBER: 'Non sei un membro?',
    ALREADY_MEMBER: 'Sei già membro di AliExpress/Alibaba?',
    EMAIL: 'E-Mail-Adresse',
    CONTACT_NAME: 'Nome di contatto:',
    FIRST_NAME: 'Nome',
    LAST_NAME: 'Cognome',
    PASSWORD: 'Passwort',
    REPASSWORD: 'Reinserisci la password:',
    EMPTY_CODE: 'Inserisci il codice visualizzato:',
    REFRESH: 'Aggiorna',
    CREATE_MY_ACCOUNT: 'Crea il mio account',
    NAME: 'Name',
    VERIFICATION: 'Nachprüfungskode',
    AGREE_MENT: 'Mit der Erstellung eines Kontos erklären Sie Ihr Einverständnis mit der und der damit verbundenen',
    AE_MEMBER_SHIP: 'Accordo di membership gratuita di AliExpress.com',
    AND: 'und',
    PRIVACY_POLICY: 'Datenschutzrichtlinie',
    SLIDE_SUBMIT: 'Zum Überprüfen nach rechts wischen',
    SLIDE_SUBMIT_TIPS: 'Erfolg',
    LOADING: 'Wird geladen ...',
    SLIDE_SUBMIT_ERROR_TIPS: 'Zum Überprüfen nach rechts wischen',
    SHOP_NOW: 'KAUFEN SOFORT',
    SIGN_IN: 'Anmelden',
    REGISTER_SMS: 'Anmeldung per SMS',
    REGISTER_EMAIL: 'Anmeldung per E-Mail',
    PHONE_NUMBER: 'Telefonnummer',
    VALID_NUMBER: 'Bitte geben Sie eine gültige Telefonnummer an.',
    SEND_SMS_CODE: 'SMS-Code senden',
    SMS_POLICY: 'Wir senden Ihnen einen Verifizierungscode per SMS an die von Ihnen angegebene Telefonnummer. Vergewissern Sie sich, dass sowohl der Ländercode als auch die Telefonnummer korrekt sind.',
    SEND_TO: 'Wir haben den Code an folgende Nummer gesendet',
    VERIFICATION_RECEIVED: 'Geben Sie den Verifizierungscode ein, den Sie erhalten haben oder',
    EDIT_NUMBER: 'bearbeiten Sie die Nummer.',
    RESEND_CODE: 'Code erneut senden',
    LAST_STEP: 'Letzter Schritt',
    SET_SIGN_IN_PASSWORD: 'Bitte legen Sie ein Passwort zum Anmelden fest, um Ihr Konto sicherer zu machen.',
    INVALID_PHONE_PASSWORD: '6 - 20 Zeichen (nur Buchstaben und Zahlen)',
    NOT_CORRECT_CODE: 'Der Code ist nicht korrekt, bitte versuchen Sie es noch einmal.',
    SAVE_PASSWORD: 'Passwort speichern',
    NO_RECEIVED_CODE: 'Wenn Sie den Code noch nicht erhalten haben, versuchen Sie,',
    VIA_EMAIL: 'sich per E-Mail anzumelden'

};